import generateVersionHash from '@utils/generateVersionHash';
import { createListMutations, createListState } from '@utils/storeHelpers';
import api from './constants';
import { postApi } from '@/lib/fetcher';

const channelProvider = {
  namespaced: true,
  state: createListState(),
  mutations: createListMutations(),
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const limit = (itemsPerPage || 10).toString();
      const pageStr = (page || 1).toString();

      const cleanedSearch = {
        provider_name: search?.provider_name || '',
        pic_name: search?.pic_name || '',
        pic_job_position: search?.pic_job_position || '',
        pic_phone_number: search?.pic_phone_number || '',
        pic_email: search?.pic_email || '',
        status: search?.status || '',
        url_callback: search?.url_callback || '',
      };

      const data = JSON.stringify({
        page: pageStr,
        limit,
        search: cleanedSearch,
        sort_by: 'id DESC',
        version: generateVersionHash(limit + pageStr, date),
      });

      const urlApi = api.GET_LIST_CHANNEL_PROVIDER;

      try {
        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code === 200) {
          ctx.commit('setTotalData', { payload: responseData });
          ctx.commit('setData', { payload: responseData });
        }
      } catch (error) {
        console.error('Error fetching Channel Provider data:', error);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async createData(ctx, { date, payload }) {
      const {
        provider_name = '',
        pic_name = '',
        pic_job_position = '',
        pic_phone_number = '',
        pic_email = '',
        url_callback = '',
      } = payload || {};

      const data = JSON.stringify({
        provider_name,
        pic_name,
        pic_job_position,
        pic_phone_number,
        pic_email,
        url_callback,
        version: generateVersionHash(
          provider_name + pic_name + pic_job_position + pic_phone_number + pic_email + url_callback,
          date
        ),
      });

      const urlApi = api.CREATE_CHANNEL_PROVIDER;
      const responseData = await postApi(ctx, urlApi, data);
      return responseData;
    },

    async updateData(ctx, { date, payload }) {
      const {
        id = '',
        provider_name = '',
        pic_name = '',
        pic_job_position = '',
        pic_phone_number = '',
        pic_email = '',
        url_callback = '',
      } = payload || {};

      const idStr = String(id);

      const data = JSON.stringify({
        id: idStr,
        provider_name,
        pic_name,
        pic_job_position,
        pic_phone_number,
        pic_email,
        url_callback,
        version: generateVersionHash(
          idStr + provider_name + pic_name + pic_job_position + pic_phone_number + pic_email + url_callback,
          date
        ),
      });

      const urlApi = api.UPDATE_CHANNEL_PROVIDER;
      const responseData = await postApi(ctx, urlApi, data);
      return responseData;
    },

    async deleteData(ctx, { date, id }) {
      const idStr = String(id);

      const data = JSON.stringify({
        id: idStr,
        version: generateVersionHash(idStr, date),
      });

      const urlApi = api.DELETE_CHANNEL_PROVIDER;
      const responseData = await postApi(ctx, urlApi, data);
      return responseData;
    },
  },
};

export default channelProvider;
